import { render, staticRenderFns } from "./ScrollBottom.vue?vue&type=template&id=76680592&lang=html&"
import script from "./ScrollBottom.ts?vue&type=script&lang=ts&"
export * from "./ScrollBottom.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports